<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            MỜI ĐỐI TÁC
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-center flex-wrap">
                            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                                <span>{{error}}</span>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-6">
                                <SelectCustomWithSearch
                                        :id="dataInvite.name_partner.id"
                                        :label="dataInvite.name_partner.label"
                                        :value-default="dataInvite.name_partner.value"
                                        @action="onChangeUseAvailable($event)"
                                        :required="dataInvite.name_partner.required"
                                        :options="dataInvite.name_partner.options"
                                        :error-text="dataInvite.name_partner.error"
                                        :is-error="dataInvite.name_partner.isError"
                                        :listCompanies="listCompanies"
                                ></SelectCustomWithSearch>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                        :label="dataInvite.code_partner.label"
                                        :id="dataInvite.code_partner.id"
                                        :placeholder="dataInvite.code_partner.placeholder"
                                        :value-default="dataInvite.code_partner.value"
                                        @inputValue="onChange($event, dataInvite.code_partner.id)"
                                        :error-text="dataInvite.code_partner.error"
                                        :is-error="dataInvite.code_partner.isError"
                                        @blur="validateForm($event, dataInvite.code_partner.id)"
                                        :required="dataInvite.code_partner.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                        :label="dataInvite.phone_partner.label"
                                        :id="dataInvite.phone_partner.id"
                                        :placeholder="dataInvite.phone_partner.placeholder"
                                        :value-default="dataInvite.phone_partner.value"
                                        @inputValue="onChange($event, dataInvite.phone_partner.id)"
                                        :error-text="dataInvite.phone_partner.error"
                                        :is-error="dataInvite.phone_partner.isError"
                                        @blur="validateForm($event, dataInvite.phone_partner.id)"
                                        :required="dataInvite.phone_partner.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                        :label="dataInvite.email_partner.label"
                                        :id="dataInvite.email_partner.id"
                                        :placeholder="dataInvite.email_partner.placeholder"
                                        :value-default="dataInvite.email_partner.value"
                                        @inputValue="onChange($event, dataInvite.email_partner.id)"
                                        :error-text="dataInvite.email_partner.error"
                                        :is-error="dataInvite.email_partner.isError"
                                        @blur="validateForm($event, dataInvite.email_partner.id)"
                                        :required="dataInvite.email_partner.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <SelectNormal
                                        :label="dataInvite.priority_partner.label"
                                        :id="dataInvite.priority_partner.id"
                                        :placeholder="dataInvite.priority_partner.placeholder"
                                        :value-default="dataInvite.priority_partner.value"
                                        :options="dataInvite.priority_partner.options"
                                        @inputValue="dataInvite.priority_partner.value = $event"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent label="Mời đối tác" @click="createPartner"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
